import { decode } from '@atc/bonnet-seo';
import { fetchSeoLocation } from '../fetchers';
import { dealerlistQuery, kbbBrand } from '../constants';
import { getPath, transformsMake, filterDealerQuery } from '../utilities';
import getValidLocationsFromSiteMap from '../utilities/getValidLocationsFromSiteMap';

export default function getSeoLocations() {
    return async (ctx) => {

        let locations = await fetchSeoLocation({
            query: {
                state: ctx.query.state,
            },
        });

        const isKbb = (ctx.data.brand === kbbBrand);
        const validLocations = new Set(await getValidLocationsFromSiteMap(isKbb));
        if (validLocations.length !== 0) {
            locations.filter((location) => {

                const [city, stateZip] = location.value.split('+');
                const [state] = stateZip.split('-');
                const locationKey = `${city.toLowerCase()}-${state.toLowerCase()}`;
                return validLocations.has(locationKey);
            });
        } else {
            locations = [];
        }

        const data = await Promise.all(locations.map(async ({ value, label }) => {
            const location = await decode(value, { param: 'location' });

            // remove unwanted parameters from the existing query string
            // eslint-disable-next-line no-unused-vars
            const { numRecords, firstRecord, sortBy, makeCode, dma, searchRadius, location: queryLocation, make, ...query } = ctx.query;
            const seoMakeCode = transformsMake(make?.toLowerCase(), true) ?? '';

            // Build a query object for the new url
            const _query = {
                ...query,
                ...location,
                seoMakeCode,
            };

            delete _query.make;
            delete _query.zip;

            const href = await getPath(ctx.pageName, filterDealerQuery(_query, dealerlistQuery), { brand: ctx.data.brand });
            return {
                href,
                label: label.replace(/\+/g, ' '),
            };
        }));

        // update the context data object with the response
        Object.assign(ctx.data, { seoLocations: data });
    };
}
